/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Logoicon1Props {
  className?: string;
}

export const Logoicon1: React.FC<Logoicon1Props> = ({ className }) => {
  return (
    <svg
      className={`logoicon-1 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="rect" fill="#0D2B7E" height="24" rx="3.31034" width="24" />
      <path
        className="path"
        d="M15.152 18.4567C18.1007 17.5913 20.2499 14.6899 20.2499 11.5153C20.2499 7.64088 17.0486 4.5 13.0997 4.5C9.4951 4.5 6.51347 7.11707 6.02095 10.5203H8.4932C8.89795 8.22748 10.8285 6.49017 13.149 6.49017C15.7635 6.49017 17.8829 8.69546 17.8829 11.4158C17.8829 14.1362 15.5812 16.3384 13.0997 16.5856C12.5962 16.6105 12.1227 16.6105 11.6295 16.6105H7.95893C8.04862 16.7126 7.86348 16.5136 7.95893 16.6105H6.71131V18.7499H11.6671C12.1602 18.7499 12.5944 18.7499 13.0997 18.7499C13.6214 18.7499 14.1299 18.6951 14.6198 18.5911C14.8065 18.5722 14.9852 18.5261 15.152 18.4567Z"
        fill="white"
      />
      <path className="path" d="M4.5 13.9269H11.4529V15.8999H4.5V13.9269Z" fill="white" />
      <path className="path" d="M6.02095 11.1865H10.5838V13.1596H6.02095V11.1865Z" fill="white" />
    </svg>
  );
};
